<template>
  <div class="users-table">
    <NoUserItemMessage v-if="!tableData || !tableData.length"/>
    <UserItem
      v-for="user in tableData"
      :key="user.id"
      :user="user"/>
  </div>
</template>
<script>
import UserItem from './UserItem.vue';
import NoUserItemMessage from './NoUserItemMessage.vue';

export default {
  components: {
    UserItem,
    NoUserItemMessage,
  },
  props: {
    tableData: { type: Array, default: () => ([]) },
  },
};
</script>
<style lang="stylus" scoped>
</style>
